










import { setCommon } from "@/utils/request";
import {
  localGet,
  setMetaData
} from "@/utils/index";
import {
  ticketClient,
} from "@/api/index";
import { WAGetMobileByUIDReq } from "@/pbjs/xcommon/ticket_pb.js";
import { Vue, Component, Provide, Watch } from "vue-property-decorator";
@Component({
  name: "WhatsappAccountSelect"
})
export default class WhatsappAccountSelect extends Vue {
  private created() {
    this.getAccountList().then((accountArr: any) => {
      this.accountArr = accountArr
      this.setCurrentAccountIndex()
    })
  }
  @Watch("currentAccountIndex")
  onCurrentAccountIndexChanged(accountIndex: number) {
    let currentAccountId = this.accountArr[accountIndex] ? this.accountArr[accountIndex].sendmobile : ''
    this.$emit('onCurrentAccountIndexChange', currentAccountId)
  }
  @Provide() public accountArr: any[] = [];
  @Provide() public currentAccountIndex: any = null;
  public setCurrentAccountIndex(currentAccountIndex?: number) {
    currentAccountIndex = currentAccountIndex ? currentAccountIndex : 0
    if (this.accountArr[currentAccountIndex]) {
      this.currentAccountIndex = currentAccountIndex
    }
  }
  private getAccountList() {
    let request: any = new WAGetMobileByUIDReq();
    request.setCommonin(setCommon());
    request.setUserid(Number(localGet("userid")))
    return new Promise(resolve => {
      ticketClient.wAGetMobileByUID(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            const data: any = response.toObject();
            if (data.commonout.code === 0) {
              resolve(data.infoList)
            } else {
              this.$message.error(data.commonout.errmsg);
            }
          } else if (err) {
            if (err.code && err.code === 16) {
              this.$router.push("./login");
            } else {
              Vue.prototype.$message({
                message: err.errmsg ? err.errmsg : err.message,
                type: "error"
              });
            }
          }
        }
      );
    })
  }
}
